/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Helmet from 'react-helmet'
import { useParams, withRouter } from 'react-router-dom'

import cogoToast from 'cogo-toast'

import UserService from '../services/UserService'
import { ROLE_NAMES } from '../utils/Constants'
import Permissions, { CAPABILITIES } from '../utils/Permissions'

export default withRouter(({ history, currentUser }) => {
  if (!Permissions.can(currentUser, CAPABILITIES.UPDATE_USER)) {
    return <h4>You do not have permissions to access this page.</h4>
  }

  const { userId } = useParams()
  const [user, setUser] = useState()
  const [allRoles, setAllRoles] = useState([])
  const [availableRoles, setAvailableRoles] = useState([])

  useEffect(() => {
    if (userId) {
      ;(async () => {
        setUser(await UserService.get(userId))
      })()
    }
  }, [setUser, userId])

  useEffect(() => {
    setAllRoles(ROLE_NAMES)
  }, [setAllRoles])

  useEffect(() => {
    const roles = [...allRoles.filter(r => !user?.roles.some(sr => sr === r.key))]
    setAvailableRoles(roles)
  }, [allRoles, user?.roles, setAvailableRoles])

  const handleOnRoleSelected = async e => {
    const value = e.target.value
    if (value) {
      try {
        const updatedUser = await UserService.addRoles(userId, [value])
        setUser(updatedUser)
      } catch (err) {
        cogoToast.error(err.message || 'Failed to add role.')
      }
    }
  }

  const handleRoleRemoval = async roleId => {
    if (roleId) {
      try {
        const updatedUser = await UserService.removeRoles(userId, [roleId])
        setUser(updatedUser)
      } catch (err) {
        cogoToast.error(err.message || 'Failed to remove role.')
      }
    }
  }

  return (
    <div>
      <Helmet title="Edit Team Member" />
      <Form className="mt-4">
        <Form.Group controlId="firstName">
          <Form.Label>First Name</Form.Label>
          <Form.Control type="text" required name="firstName" value={user?.firstName ?? ''} readOnly />
        </Form.Group>
        <Form.Group controlId="lastName">
          <Form.Label>Last Name</Form.Label>
          <Form.Control type="text" required name="lastName" value={user?.lastName ?? ''} readOnly />
        </Form.Group>
        <Form.Group controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control type="email" required name="email" value={user?.email ?? ''} readOnly />
        </Form.Group>
        <Form.Group controlId="roles">
          <Form.Label>Roles</Form.Label>
          <Form.Control as="select" onChange={handleOnRoleSelected}>
            <option></option>
            {availableRoles.map(ar => (
              <option key={ar.key} value={ar.key}>
                {ar.label}
              </option>
            ))}
          </Form.Control>
          <div className="h4 mx-n1 my-2">
            {ROLE_NAMES.filter(rn => user?.roles?.some(r => r === rn.key) === true).map(sr => (
              <Badge key={sr.key} variant="primary" className="mx-1">
                {sr.label}
                <Button type="button" size="sm" className="ml-1" onClick={() => handleRoleRemoval(sr.key)}>
                  ×
                </Button>
              </Badge>
            ))}
          </div>
        </Form.Group>
      </Form>
    </div>
  )
})
